import styled, { css, keyframes } from "styled-components";

const pictureInFromRight = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const pictureInFromLeft = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
`;

const pictureOutToLeft = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

const pictureOutToRight = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

export const MainSection = styled.section`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  padding: 52px ${({ theme }) => theme.padding.medium} 0;

  @media (max-width: 1690px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (max-width: 1400px) {
    flex-direction: column;
  }
  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.regular} 0;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.small} 0;
  }

  @media (min-width: 2500px) {
    padding: 52px ${({ theme }) => theme.padding.large} 0;
  }
  @media (min-width: 3500px) {
    padding: 52px 1.5dvw 0;
  }

  @media (min-width: 2500px) {
    padding: 52px ${({ theme }) => theme.padding.large} 0;
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.large} 0;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: ${({ theme }) => theme.padding.xlarge} 1.5dvw 0;
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.regular};

  @media (max-width: 1690px) {
    width: 50dvw;
  }
  @media (max-width: 1400px) {
    width: 100%;
  }

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const BlackCard = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.padding.regular};
  background-color: ${({ theme }) => theme.colors.darkBlue};
  color: ${({ theme }) => theme.colors.offWhite};
  max-width: 780px;

  span {
    display: flex;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.lightGreyBlue};
    border-radius: 999px;
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: flex-end;

    p {
      margin-bottom: ${({ theme }) => theme.spacing.regular};
    }
  }

  @media (min-width: 2500px) {
    max-width: 40dvw;

    span {
      width: 42px;
      height: 42px;
      min-width: 42px;
      min-height: 42px;
    }

    svg {
      width: 28px;
      height: 28px;
    }
  }
  @media (min-width: 3000px) {
    gap: 30px;
    padding: ${({ theme }) => theme.padding.medium};

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 38px;
      height: 38px;
    }
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};
    max-width: 42dvw;

    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }

    svg {
      width: 46px;
      height: 46px;
    }
  }
  @media (min-width: 3800px) {
    max-width: 46dvw;

    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }

    svg {
      width: 56px;
      height: 56px;
    }
  }
  @media (min-width: 4500px) {
    gap: ${({ theme }) => theme.spacing.medium};
    padding: 52px;

    span {
      width: 82px;
      height: 82px;
      min-width: 82px;
      min-height: 82px;
    }

    svg {
      width: 60px;
      height: 60px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }

    svg {
      width: 68px;
      height: 68px;
    }
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};

  @media (max-width: 700px) {
    flex-direction: column;
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const AccentCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.padding.regular};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.lightBlue};
  border: 1.5px solid ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.accent};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  width: 450px;
  height: 280px;
  align-items: flex-end;

  span {
    display: flex;
    width: 42px;
    height: 42px;
    min-width: 42px;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.offWhite};
    border-radius: 999px;
  }

  p {
    margin: 0;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.lightBlue};
  }

  @media (max-width: 1840px) {
    width: 400px;
  }
  @media (max-width: 1740px) {
    width: 380px;
  }
  @media (max-width: 1690px) {
    height: 100%;
    gap: 0;
  }
  @media (max-width: 1400px) {
    height: auto;
    width: 100%;
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 1024px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};

    span {
      width: 32px;
      height: 32px;
      min-width: 32px;
      min-height: 32px;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (min-width: 2500px) {
    font-size: 1.75rem;
    width: 24dvw;
    min-height: 13.5dvw;
    height: 100%;
    gap: 0;

    span {
      width: 48px;
      height: 48px;
      min-width: 48px;
      min-height: 48px;
    }

    svg {
      width: 32px;
      height: 32px;
    }
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
    padding: ${({ theme }) => theme.padding.medium};

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 42px;
      height: 42px;
    }
  }
  @media (min-width: 3400px) {
    font-size: 2.25rem;
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};

    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }

    svg {
      width: 54px;
      height: 54px;
    }
  }
  @media (min-width: 3800px) {
    font-size: 2.5rem;

    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }

    svg {
      width: 64px;
      height: 64px;
    }
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;

    span {
      width: 82px;
      height: 82px;
      min-width: 82px;
      min-height: 82px;
    }

    svg {
      width: 68px;
      height: 68px;
    }
  }
  @media (min-width: 5000px) {
    font-size: 3.5rem;

    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }

    svg {
      width: 76px;
      height: 76px;
    }
  }
`;

export const AccentCardText = styled.div`
  @media (max-width: 1690px) {
    margin: auto 0;
  }
  @media (max-width: 1400px) {
    margin: 0 0 ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 2500px) {
    margin: auto 0;
  }
`;

export const ModulesSection = styled.section`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.spacingDesktop}
    ${({ theme }) => theme.padding.medium} 0;
  align-items: center;

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.spacing.spacingTablet}
      ${({ theme }) => theme.padding.regular} 0;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.small} 0;
  }

  @media (min-width: 2500px) {
    padding: 180px ${({ theme }) => theme.padding.large} 0;
  }
  @media (min-width: 3000px) {
    padding: 200px ${({ theme }) => theme.padding.large} 0;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: 220px 1.5dvw 0;
  }
  @media (min-width: 3800px) {
    padding: 260px 1.5dvw 0;
  }
  @media (min-width: 4500px) {
    padding: 8dvw 1.5dvw 0;
  }
`;

export const ModulesHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  text-align: center;

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
`;

export const ModulesSubheader = styled.span`
  max-width: 760px;
  text-align: center;

  @media (min-width: 2500px) {
    max-width: 34dvw;
  }
  @media (min-width: 3400px) {
    max-width: 36dvw;
  }
`;

export const SliderContainer = styled.div`
  position: relative;
  width: calc(
    100% + ${({ theme }) => theme.padding.medium} +
      ${({ theme }) => theme.padding.medium}
  );
  margin-inline: calc(0px - ${({ theme }) => theme.padding.medium});
  padding: ${({ theme }) => theme.padding.regular} 0
    ${({ theme }) => theme.padding.xlarge};

  &::before {
    content: "";
    position: absolute;
    inset: 24% 0 0;
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
    background-color: ${({ theme }) => theme.colors.grey};
  }

  @media (max-width: 1024px) {
    width: calc(
      100% + ${({ theme }) => theme.padding.regular} +
        ${({ theme }) => theme.padding.regular}
    );
    margin-inline: calc(0px - ${({ theme }) => theme.padding.regular});
    padding-bottom: ${({ theme }) => theme.padding.large};

    &::before {
      border-radius: ${({ theme }) => theme.borderRadius.large};
    }
  }

  @media (max-width: 520px) {
    width: calc(
      100% + ${({ theme }) => theme.padding.small} +
        ${({ theme }) => theme.padding.small}
    );
    margin-inline: calc(0px - ${({ theme }) => theme.padding.small});
    padding: ${({ theme }) => theme.padding.small} 0
      ${({ theme }) => theme.padding.medium};

    &::before {
      inset-block-start: 18%;
      border-radius: ${({ theme }) => theme.borderRadius.medium};
    }
  }

  @media (min-width: 2500px) {
    width: calc(
      100% + ${({ theme }) => theme.padding.large} +
        ${({ theme }) => theme.padding.large}
    );
  }
  @media (min-width: 3000px) {
    width: calc(
      100% + ${({ theme }) => theme.padding.xlarge} +
        ${({ theme }) => theme.padding.xlarge}
    );
    padding: ${({ theme }) => theme.padding.regular} 0
      ${({ theme }) => theme.spacing.spacingTablet};
  }
  @media (min-width: 3500px) {
    width: calc(100% + 1.5dvw + 1.5dvw);
  }
`;

export const Slider = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 56px minmax(0, 1200px) 56px;
  justify-content: center;
  align-items: start;
  gap: clamp(24px, 5vw, 40px);
  padding-inline: ${({ theme }) => theme.padding.xlarge};

  @media (max-width: 1024px) {
    grid-template-columns: 46px minmax(0, 1fr) 46px;
    gap: ${({ theme }) => theme.spacing.regular};
    padding-inline: ${({ theme }) => theme.padding.large};
  }

  @media (max-width: 520px) {
    grid-template-columns: 34px minmax(0, 1fr) 34px;
    gap: ${({ theme }) => theme.spacing.small};
    // padding-inline: ${({ theme }) => theme.padding.small};
    padding-inline: 0;
  }

  @media (min-width: 2500px) {
    grid-template-columns: 52px minmax(0, 64dvw) 52px;
  }
  @media (min-width: 3400px) {
    grid-template-columns: 68px minmax(0, 64dvw) 68px;
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3400px) and (max-height: 1440px) {
    grid-template-columns: 52px minmax(0, 50dvw) 52px;
  }
`;

export const SliderButton = styled.button`
  grid-row: 1;
  display: inline-flex;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  justify-self: center;
  align-self: center;
  background-color: ${({ theme }) => theme.colors.controls};
  color: ${({ theme }) => theme.colors.offWhite};
  cursor: pointer;
  transition: background-color 0.35s ease,
    box-shadow 3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s ease;

  i {
    font-size: ${({ theme }) => theme.typography.h2.fontSize};

    @media (min-width: 2500px) {
      font-size: 2.5rem;
    }
    @media (min-width: 3400px) {
      font-size: 3rem;
    }
    @media (min-width: 3800px) {
      font-size: 3.5rem;
    }
    @media (min-width: 4500px) {
      font-size: 4rem;
    }
    @media (min-width: 5000px) {
      font-size: 4.5rem;
    }
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.darkBlue};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent};
    outline-offset: 3px;
  }

  &:active:not(:disabled) {
    box-shadow: ${({ theme }) => theme.shadow.buttonActive};
    transition-duration: 0.08s;
  }

  &:disabled {
    opacity: 0.55;
    cursor: default;
  }

  &:first-of-type {
    grid-column: 1;
  }

  &:last-of-type {
    grid-column: 3;
  }

  @media (max-width: 1024px) {
    width: 42px;
    height: 42px;
  }

  @media (max-width: 520px) {
    width: 24px;
    height: 24px;

    &:first-of-type {
      grid-row: 2;
    }

    &:last-of-type {
      grid-row: 2;
    }

    i {
      font-size: ${({ theme }) => theme.typography.medium.fontSize};
    }
  }

  @media (min-width: 2500px) {
    width: 52px;
    height: 52px;
  }
  @media (min-width: 3400px) {
    width: 68px;
    height: 68px;
  }
  @media (min-width: 3800px) {
    width: 76px;
    height: 76px;
  }
  @media (min-width: 4500px) {
    width: 82px;
    height: 82px;
  }
  @media (min-width: 5000px) {
    width: 92px;
    height: 92px;
  }
`;

export const SlideContent = styled.article`
  display: contents;
`;

export const SlideImage = styled.button`
  grid-column: 2;
  grid-row: 1;
  position: relative;
  width: 100%;
  padding: 0;
  aspect-ratio: 16 / 9;
  box-sizing: border-box;
  overflow: hidden;
  border: 14px solid ${({ theme }) => theme.colors.darkBlue};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadow.medium};
  cursor: zoom-in;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent};
    outline-offset: 4px;
  }

  @media (max-width: 520px) {
    border-width: 8px;
    border-radius: ${({ theme }) => theme.borderRadius.regular};

    grid-column-start: 1;
    grid-column-end: span 3;
  }

  @media (min-width: 2500px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 3000px) {
    border: 0.75dvw solid ${({ theme }) => theme.colors.darkBlue};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  }
`;

export const SlidePicture = styled.div<{
  $state: "active" | "previous" | "inactive";
  $direction: 1 | -1;
}>`
  position: absolute;
  inset: 0;
  opacity: ${({ $state }) => ($state === "inactive" ? 0 : 1)};
  visibility: ${({ $state }) => ($state === "inactive" ? "hidden" : "visible")};
  transform: ${({ $state, $direction }) =>
    $state === "active"
      ? "translateX(0)"
      : `translateX(${$direction === 1 ? -100 : 100}%)`};
  will-change: transform;

  ${({ $state, $direction }) =>
    $state === "active" &&
    css`
      animation: ${$direction === 1 ? pictureInFromRight : pictureInFromLeft}
        0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
    `}

  ${({ $state, $direction }) =>
    $state === "previous" &&
    css`
      animation: ${$direction === 1 ? pictureOutToLeft : pictureOutToRight} 0.5s
        cubic-bezier(0.22, 1, 0.36, 1) both;
    `}

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SlideCaption = styled.div`
  grid-column: 2;
  grid-row: 2;
  display: grid;
  width: 100%;
  max-width: 760px;
  justify-self: center;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.darkBlue};
  text-align: center;

  @media (max-width: 520px) {
    padding-top: ${({ theme }) => theme.padding.regular};
  }

  @media (min-width: 2500px) {
    max-width: 34dvw;
  }
  @media (min-width: 3400px) {
    max-width: 36dvw;
  }
`;

export const SlideCaptionContent = styled.div<{ $active: boolean }>`
  grid-area: 1 / 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xsmall};
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  visibility: ${({ $active }) => ($active ? "visible" : "hidden")};
  transform: translateX(${({ $active }) => ($active ? "0" : "8px")});
  transition: opacity 0.3s ease, transform 0.3s ease,
    visibility 0s linear ${({ $active }) => ($active ? "0s" : "0.3s")};

  @media (prefers-reduced-motion: reduce) {
    transform: none;
    transition: none;
  }

  @media (min-width: 2500px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
`;

export const SlideTitle = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  text-transform: uppercase;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 2.25rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.25rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.75rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.25rem;
  }
`;

export const SlideDescription = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: 1.35;
  white-space: pre-line;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.regular.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 1.5rem;
    line-height: normal;
  }
  @media (min-width: 3000px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 2.575rem;
  }
  @media (min-width: 4500px) {
    font-size: 3rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.5rem;
  }
`;

export const FeatureSection = styled.section`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.spacingDesktop}
    ${({ theme }) => theme.padding.medium};
  align-items: center;
  text-align: center;

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.spacing.spacingTablet}
      ${({ theme }) => theme.padding.regular};
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.small};
  }

  @media (min-width: 2500px) {
    padding: 200px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: 260px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 300px 1.5dvw;
  }
  @media (min-width: 4500px) {
    padding: 8dvw 1.5dvw;
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing.regular};
  align-items: center;
  text-align: left;

  @media (max-width: 1366px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const FeatureCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.padding.regular};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.darkBlue};
  height: 200px;
  box-shadow: 0 4px 8px rgba(191, 191, 191, 0.25);

  @media (max-width: 1840px) {
    height: 230px;
  }
  @media (max-width: 1690px) {
    height: 250px;
  }
  @media (max-width: 1024px) {
    gap: ${({ theme }) => theme.spacing.regular};
    height: 220px;
  }
  @media (max-width: 700px) {
    height: 200px;
  }

  @media (min-width: 2500px) {
    height: calc(1.5rem * 12);
  }
  @media (min-width: 3000px) {
    height: calc(1.75rem * 12);
    padding: ${({ theme }) => theme.padding.medium};
  }
  @media (min-width: 3400px) {
    height: calc(2.25rem * 14);
    min-height: 100%;
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};
    gap: 52px;
  }
  @media (min-width: 3800px) {
    height: calc(2.575rem * 14);
  }
  @media (min-width: 4500px) {
    height: calc(3rem * 14);
  }
  @media (min-width: 5000px) {
    height: calc(3.5rem * 14);
    padding: 52px;
  }
`;

export const FeatureCardHeading = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
  max-height: 30px;

  span {
    display: flex;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.darkBlue};
    border-radius: 999px;
  }

  svg {
    width: 24px;
    height: 24px;
  }

  p {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
    font-weight: ${({ theme }) => theme.fontWeight.extrabold};
    word-spacing: 3px;
    text-transform: uppercase;
    margin: 0;

    @media (min-width: 2500px) {
      font-size: 1.5rem;
    }
    @media (min-width: 3000px) {
      font-size: 1.75rem;
    }
    @media (min-width: 3400px) {
      font-size: 2.25rem;
    }
    @media (min-width: 3800px) {
      font-size: 2.575rem;
    }
    @media (min-width: 4500px) {
      font-size: 3rem;
    }
    @media (min-width: 5000px) {
      font-size: 3.5rem;
    }
  }

  @media (min-width: 2500px) {
    gap: ${({ theme }) => theme.spacing.regular};
    max-height: fit-content;

    span {
      width: 42px;
      height: 42px;
      min-width: 42px;
      min-height: 42px;
    }

    svg {
      width: 32px;
      height: 32px;
    }
  }
  @media (min-width: 3000px) {
    gap: 30px;

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 42px;
      height: 42px;
    }
  }
  @media (min-width: 3400px) {
    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }

    svg {
      width: 50px;
      height: 50px;
    }
  }
  @media (min-width: 3800px) {
    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }

    svg {
      width: 60px;
      height: 60px;
    }
  }
  @media (min-width: 4500px) {
    gap: ${({ theme }) => theme.spacing.medium};

    span {
      width: 82px;
      height: 82px;
      min-width: 82px;
      min-height: 82px;
    }

    svg {
      width: 64px;
      height: 64px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }

    svg {
      width: 72px;
      height: 72px;
    }
  }
`;
